import { render, staticRenderFns } from "./ViewInvoicePage.vue?vue&type=template&id=33898938&scoped=true"
import script from "./ViewInvoicePage.vue?vue&type=script&lang=js"
export * from "./ViewInvoicePage.vue?vue&type=script&lang=js"
import style0 from "./ViewInvoicePage.vue?vue&type=style&index=0&id=33898938&prod&lang=css"
import style1 from "./ViewInvoicePage.vue?vue&type=style&index=1&id=33898938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33898938",
  null
  
)

export default component.exports